import type { RelightParams } from './types';
import { imageModels } from '@flowmuse/models/image';

export const RELIGHT_IMAGE_MODEL_ID = 'relight';

/**
 * Define how Relight tool becomes an Image node run.
 * We store params both under `tool.params` (for provenance) and `modelUi` (for providerOptions mapping).
 */
export const buildRelightImageNodeData = ({
  params,
  now,
  // legacy: previously passed through, but not persisted (kept for call-site compatibility)
  sourceToolNodeId: _sourceToolNodeId,
}: {
  params: RelightParams;
  now: string;
  sourceToolNodeId?: string;
}): Record<string, unknown> => {
  return {
    // Use the image model's label as the node name (shown in EditableNodeTitle)
    name: (imageModels as any)?.[RELIGHT_IMAGE_MODEL_ID]?.label ?? 'Relight',
    viewMode: 'transform',
    model: RELIGHT_IMAGE_MODEL_ID,
    modelUi: {
      light_direction: params.light_direction,
      light_intensity: params.light_intensity,
      light_temperature: params.light_temperature,
      light_type: params.light_type,
      // Upstream image input (model can be configured to read this directly)
      source_image_url: params.source_image_url,
    },
    // Clear previous outputs/processing state to allow a fresh run
    generated: undefined,
    status: undefined,
    processingTaskId: undefined,
    processingGenerationId: undefined,
    updatedAt: now,
  };
};


